import {ReactNode} from "react";
import {Box} from "@mantine/core";

export const showGTZero = (value: number, node: ReactNode) => {
    if (value > 0) {
        return node
    } else {
        return <Box/>
    }
}